import { message } from "antd";

const normalize = (value) => (value || "").trim().toLowerCase();

export const validateFieldByLength = (field, messageText) => {
  if (!field || field.length === 0) {
    message.error(messageText);
    return false;
  }
  return true;
};

export function validateDuplicateFolderDisplayNames(rows, existingRows = []) {
  const existingSet = new Set(
    (existingRows || []).map((r) => normalize(r.description)).filter(Boolean),
  );
  const seen = new Set();

  for (const row of rows || []) {
    const key = normalize(row.description);
    if (!key) continue;
    if (existingSet.has(key)) {
      const displayName = (row.description || "").trim();
      return `Folder name "${displayName}" already exists for this environment.`;
    }
    if (seen.has(key)) {
      return "Duplicate folder display names are not allowed.";
    }
    seen.add(key);
  }
  return null;
}
